import axios from 'axios';

const api = axios.create({
  baseURL: '/api/lostark/schedule',
  headers: { 'Content-Type': 'application/json' },
});

export default api;
